import { LOADED, LOADING } from '../../../shared/constants/readyStates';
import {
  FETCH_COMPANIES,
  RETRIEVED_COMPANIES,
  RETRIEVED_USERS,
} from './actions';
import { rehydrate } from '../../../store/localStorage';


const initState = {
  companies: {
    data: [],
    total: 0,
    maxRow: 50,
    activePage: 1,
  },
  userPending: {
    users: [],
    loading: true,
  },
  loading: true,
};

const reducer = (state = rehydrate('features', initState), action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: true };

    case LOADED:
      return { ...state, loading: false };

    case RETRIEVED_COMPANIES: {
      const companies = state.companies;
      companies.data = action.companies;
      companies.total = action.total;
      return { ...state, companies };
    }

    case FETCH_COMPANIES: {
      return { ...state, companies: [...action.companies] };
    }

    case RETRIEVED_USERS: {
      const userPending = state.userPending;
      userPending.users = action.users;
      return { ...state, userPending };
    }

    default:
      return state;
  }
};

export default reducer;
